import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Modal de decisión reutilizable, inspirado en el patrón de alerta modal GOV.CO. */
@Component({
  selector: 'sr-psa-govco-confirm-modal',
  standalone: true,
  templateUrl: './govco-confirm-modal.component.html',
  styleUrl: './govco-confirm-modal.component.css'
})
export class GovcoConfirmModalComponent {
  @Input() open = false;
  @Input() title = '¿Desea continuar?';
  @Input() message = '';
  @Input() confirmLabel = 'Sí, confirmar';
  @Input() cancelLabel = 'No, volver';
  @Input() showCancel = true;
  @Input() variant: 'warning' | 'success' = 'warning';
  @Output() readonly confirmed = new EventEmitter<void>();
  @Output() readonly closed = new EventEmitter<void>();
}
